import Hero from "./components/Hero";
import Trends from "./components/Trends";

const Home = () => {
  return (
    <>
      <Hero />
      <Trends />
    </>
  );
};

export default Home;
